/**
 * 错误类
 * @param {*} message 
 * @param {*} target 
 * @param {*} other 
 * @param {*} other.ignore 忽略 错误提示不会显示到页面上
 * @param {*} other.formula 公式 审核公式对象
 * @param {*} other.mandatoryType 公式 审核公式 强制类型 1-强制性 2-准强制性 3-核实性 4-可忽略性 没有则是普通列表的验证
 * @param {*} other.mandatoryTypeText 公式 审核公式 强制类型 1-强制性 2-准强制性 3-核实性 4-可忽略性 没有则是普通列表的验证
 */
function ValidateError(message, target, other) {
  this.message = message;
  this.target = target;
  if (other) {
    this.info = {
      ...other
    };
  } else {
    this.info = {};
  }
}
//开放全局变量，二次开发时无法使用import时可以使用该全局变量混入
if (window) {
  window.$$ValidateError = ValidateError;
}
export default ValidateError